import roomsData from '../data/rooms.json';

export interface Room {
  id: string;
  name: string;
  type: string;
  description: string;
  basePrice: number;
  discountedPrice?: number | null;
  capacity: {
    adults: number;
    children: number;
  };
  size: {
    squareFeet: number;
    squareMeters: number;
  };
  beds: Array<{
    type: 'single' | 'double' | 'queen' | 'king';
    count: number;
  }>;
  amenities: string[];
  images: string[];
  status: 'available' | 'occupied' | 'maintenance' | 'cleaning';
  features: {
    isSmokingAllowed: boolean;
    isPetFriendly: boolean;
    hasBalcony: boolean;
    hasWindowView: boolean;
    isAccessible: boolean;
  };
  policies: {
    checkInTime: string;
    checkOutTime: string;
    cancellationHours: number;
    extraBedAllowed: boolean;
    extraBedCharge?: number | null;
  };
  location: {
    floor: number;
    wing: string;
    roomNumber: string;
  };
}

const allRooms = roomsData.rooms as Room[];

export const fetchRooms = async (): Promise<Room[]> => {
  return [...allRooms].sort((a, b) => a.basePrice - b.basePrice);
};

export const fetchAvailableRooms = async (): Promise<Room[]> => {
  try {
    return allRooms
      .filter(room => room.status === 'available')
      .sort((a, b) => a.basePrice - b.basePrice);
  } catch (error) {
    console.error('Error fetching available rooms:', error);
    return [];
  }
};

export const getRoomById = (id: string): Room | undefined => {
  return allRooms.find(room => room.id === id);
};